/** The CRI mark, inline rather than an <img>.

Inlining is what lets the artwork be ONE copy across both themes: the navy ink resolves
through --mark-ink, which the dark theme restates as white. It is also vector, so no
size can pixelate it - the header renders it at 22px and the login card at 40px from the
same paths. Sourced from the official Illustrator export; the path data is verbatim. */
export default function BrandMark({ className = "" }: { className?: string }) {
  return (
    <svg
      className={`brand-mark ${className}`}
      viewBox="236 365 608 349"
      role="img"
      aria-label="CRI"
      focusable="false"
    >
      <path fill={"var(--mark-ink)"} d="M454.91,637.7c-11,45.55-50.12,76.06-99.9,76.06c-66.57,0-118.16-51.01-118.16-118.87 c0-74.24,47.94-122.56,120.44-122.56c54.34,0,97.12,26.4,97.12,56.98c0,12.74-7.33,22.77-21.89,22.77 c-36.94,0-23.72-72.41-71.6-72.41c-38.77,0-67.05,46.46-67.05,107.48c0,60.58,36.03,104.75,82.49,104.75 c32.81,0,60.2-21.45,72.59-56.09L454.91,637.7z" />
      <path fill={"var(--brand-gold)"} d="M743.61,509.32h-31.46v-6.83c15.05-0.91,70.69-16.84,81.19-25.51h8.25v203.06c0,13.68,16.42,22.32,41.56,22.32 v6.83H707.58v-6.85c25.09,0,41.56-8.64,41.56-22.32V514.72C749.09,511.09,747.27,509.32,743.61,509.32z" />
      <path fill={"var(--brand-gold)"} d="M775.55,366.25c42.22-0.58,41.74,63.98,0,63.3C734.97,430.23,734.5,365.66,775.55,366.25z" />
      <path fill={"var(--mark-ink)"} d="M689.63,493.6l-34.22-31.64l-0.89,9.35c-30.69,1.52-48.08,12.65-48.08,12.65 c-18.66,9.4-34.58,23.48-46.19,40.85v-47.84h-8.6c-10.01,8.66-65.66,24.6-80.66,25.51v6.85h31.48c3.66,0,5.46,1.83,5.46,5.46 v165.26c0,13.68-16.88,22.32-41.56,22.32v6.83h135.45v-6.85c-24.63,0-41.49-8.64-41.49-22.32V537.49c0.56-0.78,1.12-1.55,1.65-2.29 l13.35-15.97c37.09-31.56,67.64-16.3,75.61-11.32c0,3.12,0.15,6.24,0.15,9.37v0.3L689.63,493.6z" />
    </svg>
  );
}
